// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteUnidades_UploadFotoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for POST /config/site_unidades/upload_foto — the public URL of the stored photo. */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SiteUnidades_UploadFotoResponseDados {
url: string
}

export type SiteUnidades_UploadFotoResponse = ApiResponse<SiteUnidades_UploadFotoResponseDados>;

registerResponseContract('SiteUnidades_UploadFotoResponse', {
  url: { type: 'string',  required: true },
})
